
const Default = {

    filter(value, defaultValue) {

        return value || defaultValue;

    },

};

export default Default;



// WEBPACK FOOTER //
// ./scripts/common/filters/-RFC.default.js